import { degreeDaysKeyForInsect } from 'App/dashboards/_utils/pestValueTypeKeys'
import type { TFieldAssetStoreState } from 'stores/fieldAssetStore/fieldAssetStore'
import { sortByKey } from 'utils/sortByKey'

export type TWeatherStationInfo = {
  lngLat: string
  stationName: string
}

// Degree days are requested at the `points` scope: one line per weather station. A point advertises
// the degree day value type in `valuesTimeseries` only when it has air-temperature-in AND the user is
// permitted (see pgSelectValueTypesPoints.sql), so this filter naturally selects weather stations and
// excludes traps/pressure/irrigation points. Same shape/idea as getBlocksForProperty.
export const getWeatherStationsForProperty = ({
  properties,
  propertyId,
  insectId,
}: {
  properties: TFieldAssetStoreState['properties']
  propertyId: number | null
  insectId: number
}): TWeatherStationInfo[] => {
  if (propertyId === null) return []

  const property = properties?.[propertyId]

  if (!property) return []

  const points = Object.values(property.points ?? {})
  const ddValueTypeKey = degreeDaysKeyForInsect(insectId)

  return (
    points
      .filter((p) => p.valuesTimeseries?.some((vt) => vt === ddValueTypeKey))
      .map((p): TWeatherStationInfo => ({
        lngLat: p.lngLat,
        stationName: p.name || p.lngLat,
      }))
      // Natural sort (sortByKey → alphabeticalSort uses Intl.Collator numeric) so e.g. "CRO 3" precedes
      // "CRO 11" rather than string-sorting "11" before "3".
      .sort(sortByKey('stationName'))
  )
}
